/* eslint-disable consistent-return */
/* eslint-disable no-lone-blocks */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  Suspense,
  forwardRef,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Layer,
  Pane,
  PaneFooter,
  Paneset,
} from '@folio/stripes-components';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FormattedMessage } from 'react-intl';
import createDecorator from 'final-form-focus';
import Stepper from '../Stepper';
import styles from './styles.css';
import { useFormPageErrorsContext } from '../../providers/FormPagesErrorsProvider';
import ActiveLockBanner from '../../components/shared/RecordLocking/ActiveLockBanner';

const propTypes = {
  initialValues: PropTypes.object,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  pages: PropTypes.arrayOf(PropTypes.object),
  paneTitle: PropTypes.node,
  appIcon: PropTypes.node,
  formId: PropTypes.string,
  onClose: PropTypes.func,
  isPageSave: PropTypes.bool,
  lastMenu: PropTypes.node,
  showLockBanner: PropTypes.bool,
  lockInfo: PropTypes.object,
};

const focusOnError = createDecorator();

const WizardForm = forwardRef(({
  children,
  initialValues,
  onSubmit,
  pages,
  paneTitle,
  appIcon,
  formId,
  onClose,
  lastMenu,
  // hasError = false,
  isPageSave = false,
  showLockBanner = false,
  lockInfo,
}, ref) => {
  const [formInitialValues, setFormInitialValues] = useState({});
  const [pageNumber, setPageNumber] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [showErrorPanel, setShowErrorPanel] = useState(false);
  const { hasAnyError, resetErrors, errorMap } = useFormPageErrorsContext();

  useEffect(() => {
    if (initialValues) {
      setFormInitialValues(initialValues);
    }
  }, [initialValues]);

  useEffect(() => {
    if (!hasAnyError) {
      setShowErrorPanel(false);
    }
  }, [hasAnyError]);

  const activePage = useMemo(
    () => React.Children.toArray(children)[pageNumber],
    [pageNumber, children],
  );

  const isLastPage = useMemo(
    () => pageNumber === React.Children.count(children) - 1,
    [pageNumber, children],
  );

  const onNextStep = useCallback(
    (values) => {
      if (!hasAnyError) {
        setPageNumber(Math.min(pageNumber + 1, children.length - 1));
        setIsComplete(true);
        setFormInitialValues(values);
      }
    },
    [hasAnyError, pageNumber, children.length],
  );

  const onBackStep = useCallback(() => {
    resetErrors();
    setPageNumber(Math.max(pageNumber - 1, 0));
    setIsComplete(false);
  }, [pageNumber]);

  const validate = useCallback(
    (values) =>
      activePage.props.validate ? activePage.props.validate(values) : {},
    [activePage],
  );

  const hasErrors = () => {
    return (
      <div
        style={{
          marginTop: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'sticky',
          fontWeight: 'bold',
          color: 'darkred',
          border: '1px solid darkred',
          height: '35px',
          textAlign: 'center',
        }}
      >
        <FormattedMessage
          id="ui-plugin-inventory-templates.instanceWizard.callout.errors"
          defaultMessage="There are some errors on this page, you must fix them first before moving to the next page, swipe up or down to see the errors below each field"
        />
      </div>
    );
  };

  const onHandleSubmit = useCallback(
    (values) => {
      if (hasAnyError) return;
      return isLastPage ? onSubmit(values) : onNextStep(values);
    },
    [hasAnyError, isLastPage, onSubmit, onNextStep],
  );

  const renderPaneFooter = (pristine, submitting, submit) => {
    return (
      <PaneFooter
        renderEnd={
          <>
            {!isLastPage && (
              <>
                <Button
                  buttonStyle="mega primary"
                  //   disabled={pristine || submitting}
                  id="create-new-instance-pane-footer-next-btn"
                  marginBottom0
                  onMouseDown={(e) => e.preventDefault()}
                  type="submit"
                  onClick={(event) => {
                    submit(event);
                  }}
                >
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.createNewInstance.pane.footer.nextBtn"
                    values={{ nextPage: pages[pageNumber + 1].name }}
                    defaultMessage="Next: {nextPage}"
                  />
                  <div className={styles.icon}>
                    <Icon icon="arrow-right" />
                  </div>
                </Button>
                {isPageSave && (
                  <Button
                    buttonStyle="mega primary"
                    //   disabled={pristine || submitting}
                    id="create-new-instance-pane-footer-submit-btn"
                    marginBottom0
                    type="submit"
                    onClick={(event) => {
                      submit(event);
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    <FormattedMessage
                      id="stripes-components.saveAndClose"
                      defaultMessage="Save and close"
                    />
                  </Button>
                )}
              </>
            )}
            {isLastPage && (
              <Button
                buttonStyle="mega primary"
                disabled={pristine || submitting}
                id="create-new-instance-pane-footer-submit-btn"
                marginBottom0
                type="submit"
                onClick={(event) => {
                  submit(event);
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <FormattedMessage
                  id="ui-plugin-inventory-templates.createNewInstance.pane.footer.submitBtn"
                  defaultMessage="Submit"
                />
              </Button>
            )}
          </>
        }
        renderStart={
          pageNumber > 0 && (
            <Button
              buttonStyle="mega primary"
              id="create-new-instance-pane-footer-previous-btn"
              marginBottom0
              onClick={onBackStep}
            >
              <Icon icon="arrow-left">
                <FormattedMessage
                  id="ui-plugin-inventory-templates.createNewInstance.pane.footer.previousBtn"
                  values={{ prevPage: pages[pageNumber - 1].name }}
                  defaultMessage="Previous: {prevPage}"
                />
              </Icon>
            </Button>
          )
        }
      />
    );
  };

  return (
    <Form
      validate={validate}
      onSubmit={onHandleSubmit}
      initialValues={formInitialValues}
      subscription={{
        handleSubmit: true,
        submitFailed: true,
        errors: true,
        submitting: true,
      }}
      decorators={[focusOnError]}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, pristine, submitting, submitFailed, errors, form }) => {
        // Expose form API through ref
        if (ref) {
          if (typeof ref === 'object') {
            ref.current = form;
          } else if (typeof ref === 'function') {
            ref(form);
          }
        }
        
        return (
          <Paneset>
            <Layer
              isOpen
              contentLabel="ui-quick-marc.record.quickMarcEditorLabel"
            >
              <Pane
                id={`${formId}-pane`}
                appIcon={appIcon || <div />}
                paneTitle={paneTitle}
                subheader={
                  <div className={styles.form_stepper}>
                    {/* <Stepper currentStep={pageNumber} steps={pages} /> */}
                    {showLockBanner && lockInfo && (
                      <ActiveLockBanner lockInfo={lockInfo} />
                    )}
                    {((submitFailed && Object.keys(errors).length > 0) ||
                      showErrorPanel) &&
                      hasErrors()}
                  </div>
                }
                fluidContentWidth
                centeredContent
                footer={renderPaneFooter(pristine, submitting, handleSubmit)}
                dismissible
                onClose={onClose}
                lastMenu={lastMenu}
              >
                <form id={`${formId}-form`} onSubmit={handleSubmit}>
                  <Suspense fallback={<div>Loading step...</div>}>
                    {activePage}
                  </Suspense>
                </form>
              </Pane>
            </Layer>
          </Paneset>
        );
      }}
    </Form>
  );
});

WizardForm.Page = ({ children }) => children;

WizardForm.propTypes = propTypes;

export default WizardForm;
